"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingGateDialog = void 0;
const Leaf = __importStar(require("leaf-ts"));
const log_consensus_1 = require("@branch-ts/log-consensus");
const web_1 = require("@branch-ts/web");
const billingGateDialog_html_R_1 = require("./billingGateDialog.html.R");
const billingGateDialog_html_R_2 = require("./billingGateDialog.theme/genesis/billingGateDialog.html.R");
const billingGateDialog_html_R_3 = require("./billingGateDialog.theme/business/billingGateDialog.html.R");
const versetFacilityMechanism_1 = require("../versetFacilityMechanism");
const versetUserProfileMechanism_1 = require("../versetUserProfileMechanism");
const defaultAmountMinor = 2_000;
const pollIntervalMs = 4_000;
class BillingGateDialog extends billingGateDialog_html_R_1.R.BillingGateDialog {
    constructor() {
        super();
        this.asPopup = new web_1.PopupBehavior(this).center();
        this.stages = new web_1.StagesBehavior(this).defines({ hasSource: "hide", state: "choose" });
        this.checkoutWindow = null;
        this.pendingPaymentId = null;
        this.pendingRequestId = null;
        this.pendingAmountMinor = null;
        this.pollTimer = null;
        this.polling = false;
        this.opening = false;
        this.isVisible = false;
        this.checkoutURI = null;
        this.UI.amount.value = this.formatAmount(defaultAmountMinor);
        this.asPopup.events.listenBy(this, "show", () => {
            this.isVisible = true;
            if (this.pendingPaymentId)
                void this.pollStatus();
        });
        this.asPopup.events.listenBy(this, "hide", () => {
            this.isVisible = false;
            this.stopPolling();
        });
    }
    get server() {
        return versetFacilityMechanism_1.VersetFacilityMechanism.ensureServer();
    }
    show(option = {}) {
        this.VM.source = option.source || "";
        this.stages.set("hasSource", option.source ? "show" : "hide");
        if (!this.pendingPaymentId && !this.pendingRequestId && !this.opening)
            this.showChoose();
        log_consensus_1.Logger.log("Verset conversion", { step: "offerShown", kind: "additionalUsage" });
        void this.asPopup.show();
    }
    onClickAmount5(e) { e?.preventDefault(); e?.stopPropagation(); this.setAmount(500); }
    onClickAmount20(e) { e?.preventDefault(); e?.stopPropagation(); this.setAmount(2_000); }
    onClickAmount50(e) { e?.preventDefault(); e?.stopPropagation(); this.setAmount(5_000); }
    onClickAmount100(e) { e?.preventDefault(); e?.stopPropagation(); this.setAmount(10_000); }
    onInputAmount() { this.setHint(""); }
    async onClickOpenCheckout(e) {
        e?.preventDefault();
        e?.stopPropagation();
        if (this.opening || this.pendingPaymentId)
            return;
        const amountMinor = this.pendingAmountMinor ?? this.parseAmount(this.UI.amount.value);
        if (amountMinor == null) {
            this.setHint("Enter a whole-dollar amount from $5 to $1,000.");
            return;
        }
        this.opening = true;
        this.pendingAmountMinor = amountMinor;
        // Retain identity even if transport fails after the server creates checkout.
        const requestId = this.pendingRequestId || this.createRequestId();
        this.pendingRequestId = requestId;
        this.stages.set("state", "opening");
        this.setHint("Preparing secure checkout…");
        this.UI.openCheckout.disabled = true;
        this.UI.amount.disabled = true;
        this.checkoutWindow = window.open("", "verset-additional-usage-checkout");
        try {
            const [result, reason, ...errors] = await this.server.rpcs.VersetUserBillingService.createMyPreChargeCheckout({ amountMinor, requestId });
            if (reason || !result) {
                this.checkoutWindow?.close();
                this.checkoutWindow = null;
                this.stages.set("state", "choose");
                this.setHint(this.describeCheckoutError(reason, errors));
                return;
            }
            this.pendingPaymentId = result.paymentId;
            this.checkoutURI = result.checkoutURI;
            this.VM.amount = this.formatAmount(result.amountMinor);
            this.VM.expectedPointAmount = `${(result.amountMinor * 100).toLocaleString()} VP`;
            if (!this.checkoutWindow || this.checkoutWindow.closed) {
                this.checkoutWindow = null;
                this.stages.set("state", "attention");
                this.setHint("Your browser blocked checkout. Use the secure link below; we will keep checking payment.");
            }
            else {
                this.checkoutWindow.location.href = result.checkoutURI;
                this.stages.set("state", "confirming");
                this.setHint("Keep your work open here while we confirm payment.");
                log_consensus_1.Logger.log("Verset conversion", { step: "checkoutOpened", kind: "additionalUsage" });
            }
            void this.pollStatus();
        }
        catch {
            this.checkoutWindow?.close();
            this.checkoutWindow = null;
            this.stages.set("state", "choose");
            this.setHint("Checkout preparation could not be confirmed. Retry uses the same payment request and amount.");
        }
        finally {
            this.opening = false;
            this.UI.openCheckout.disabled = !!this.pendingPaymentId;
        }
    }
    onClickOpenCheckoutLink(e) {
        e?.preventDefault();
        e?.stopPropagation();
        if (!this.checkoutURI || !this.pendingPaymentId)
            return;
        this.checkoutWindow = window.open(this.checkoutURI, "verset-additional-usage-checkout");
        if (this.checkoutWindow) {
            this.stages.set("state", "confirming");
            this.setHint("Keep your work open here while we confirm payment.");
            log_consensus_1.Logger.log("Verset conversion", { step: "checkoutOpened", kind: "additionalUsage" });
        }
        void this.pollStatus();
    }
    onClickDismiss(e) {
        e?.preventDefault();
        e?.stopPropagation();
        log_consensus_1.Logger.log("Verset conversion", { step: this.stages.get("state") === "settled" ? "returnedToWork" : "offerDismissed", kind: "additionalUsage" });
        this.asPopup.hide();
    }
    async pollStatus() {
        const paymentId = this.pendingPaymentId;
        if (!paymentId || !this.isVisible || this.polling)
            return;
        this.stopPolling();
        this.polling = true;
        try {
            const [result, reason] = await this.server.rpcs.VersetUserBillingService.getMyPreChargeStatus({ paymentId });
            if (paymentId !== this.pendingPaymentId || !this.isVisible)
                return;
            if (!reason && result?.state === "settled") {
                this.stages.set("state", "settled");
                this.setHint(`${result.expectedPointAmount.toLocaleString()} VP is ready. Return to your work and retry when you’re ready.`);
                this.pendingPaymentId = null;
                this.pendingRequestId = null;
                this.pendingAmountMinor = null;
                this.checkoutURI = null;
                this.checkoutWindow = null;
                this.UI.openCheckout.disabled = false;
                this.UI.amount.disabled = false;
                log_consensus_1.Logger.log("Verset conversion", { step: "paymentConfirmed", kind: "additionalUsage" });
                versetUserProfileMechanism_1.VersetUserProfileMechanism.refreshFromCheckout();
                return;
            }
            if (!reason && result?.state === "needsAttention") {
                this.stages.set("state", "attention");
                this.UI.openCheckoutLink.disabled = true;
                this.setHint("Payment needs attention. Please review billing history or contact support; do not pay again.");
                return;
            }
            if (this.checkoutWindow?.closed) {
                this.checkoutWindow = null;
                this.stages.set("state", "attention");
                this.setHint("Checkout closed. We are still checking for confirmation. Reopen the same checkout below if needed.");
            }
        }
        catch {
            this.setHint("Payment status is temporarily unavailable. We will keep checking; do not pay again.");
        }
        finally {
            this.polling = false;
            if (this.pendingPaymentId && this.isVisible && !this.UI.openCheckoutLink.disabled) {
                this.pollTimer = window.setTimeout(() => void this.pollStatus(), pollIntervalMs);
            }
        }
    }
    showChoose() {
        this.checkoutWindow = null;
        this.checkoutURI = null;
        this.UI.openCheckout.disabled = false;
        this.UI.openCheckoutLink.disabled = false;
        this.UI.amount.disabled = false;
        this.stages.set("state", "choose");
        this.setHint("$5–$1,000 USD, in whole-dollar increments. $1 = 10,000 VP.");
    }
    setAmount(amountMinor) {
        if (this.pendingRequestId || this.opening)
            return;
        this.UI.amount.value = this.formatAmount(amountMinor);
        this.setHint("");
    }
    parseAmount(value) {
        const match = /^(\d+)(?:\.00)?$/.exec(value.trim().replace(/^\$/, ""));
        if (!match)
            return undefined;
        const amountMinor = Number(match[1]) * 100;
        return Number.isSafeInteger(amountMinor) && amountMinor >= 500 && amountMinor <= 100_000 ? amountMinor : undefined;
    }
    formatAmount(amountMinor) { return `$${(amountMinor / 100).toFixed(2)}`; }
    createRequestId() { return `${Date.now()}-${crypto.getRandomValues(new Uint32Array(1))[0].toString(16)}`; }
    setHint(hint) { this.VM.hint = hint; }
    stopPolling() {
        if (this.pollTimer != null) {
            window.clearTimeout(this.pollTimer);
            this.pollTimer = null;
        }
    }
    describeCheckoutError(reason, errors) {
        const detail = errors.map(error => error instanceof Error ? error.message : String(error)).filter(Boolean)[0];
        return detail || (reason === "InvalidAmount" ? "Enter a whole-dollar amount from $5 to $1,000." : "We could not open checkout. Retry uses the same payment request and amount.");
    }
}
exports.BillingGateDialog = BillingGateDialog;
Leaf.WidgetThemeCenter.about(billingGateDialog_html_R_1.R.BillingGateDialog).add("genesis", billingGateDialog_html_R_2.R.BillingGateDialog.generator);
Leaf.WidgetThemeCenter.about(billingGateDialog_html_R_1.R.BillingGateDialog).add("business", billingGateDialog_html_R_3.R.BillingGateDialog.generator);
